import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
import Small from 'UIComponents/elements/Small';
import UIBadge from 'UIComponents/badge/UIBadge';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import UIList from 'UIComponents/list/UIList';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import { MINIMUM_REVIEWS_FOR_DISPLAY } from 'ecosystem-marketplace-core/constants/reviews/ReviewsListQueries';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { STAR_RATING_FILLED } from 'ecosystem-marketplace-core/constants/reviews/RatingTypes';
import { formatCentsToDollars } from 'ecosystem-marketplace-core/utils/currency';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
const StyledPrice = styled(AbstractTextElement).withConfig({
  displayName: "ThemeListViewCard__StyledPrice",
  componentId: "sc-8l3rri-0"
})(["font-size:20px;"]);
StyledPrice.displayName = 'StyledPrice';

const ThemeListViewCard = (_ref) => {
  let {
    demoButton,
    detailsButton,
    featureHeadlines,
    installsCount,
    name,
    priceCents,
    providerName,
    reviewSummary,
    thumbnailUrl
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["demoButton", "detailsButton", "featureHeadlines", "installsCount", "name", "priceCents", "providerName", "reviewSummary", "thumbnailUrl"]);

  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  return /*#__PURE__*/_jsx(UICardWrapper, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UIMultiColumn, {
      flush: true,
      className: "p-all-4",
      children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
          className: "p-right-0",
          width: "275px",
          children: /*#__PURE__*/_jsx(UIImage, {
            shape: "thumbnail",
            src: thumbnailUrl,
            style: {
              maxHeight: !isMobileView ? 200 : undefined
            }
          })
        }), /*#__PURE__*/_jsxs(UIMultiColumnItem, {
          verticalAlign: "top",
          className: "p-top-1",
          children: [/*#__PURE__*/_jsx("div", {
            className: "is--heading-4 m-bottom-0",
            children: name
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystemMarketplaceCore.cards.assetCard.companyName",
                options: {
                  companyName: providerName || ''
                }
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "p-top-1 p-bottom-2",
            children: /*#__PURE__*/_jsx(UIBadge, {
              use: "koala",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystemMarketplaceCore.cards.assetCard.offeringType.THEME"
              })
            })
          }), /*#__PURE__*/_jsx(UIList, {
            className: "m-left-4 p-left-0",
            styled: true,
            children: featureHeadlines.map((item, index) => /*#__PURE__*/_jsx(Small, {
              children: item
            }, `featuredheadline-${index}`))
          })]
        }), /*#__PURE__*/_jsxs(UIMultiColumnItem, {
          className: "p-left-0",
          width: "200px",
          horizontalAlign: "center",
          children: [/*#__PURE__*/_jsx("div", {
            children: priceCents != null ? /*#__PURE__*/_jsx(StyledPrice, {
              weight: "medium",
              children: priceCents === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystemMarketplaceCore.cards.assetCard.planType.free"
              }) : /*#__PURE__*/_jsx(FormattedCurrency, {
                currencyCode: "USD",
                simplifyCurrency: true,
                value: formatCentsToDollars(priceCents)
              })
            }) : null
          }), /*#__PURE__*/_jsx("div", {
            className: "p-top-2 p-bottom-2",
            children: reviewSummary && reviewSummary.reviewCount >= MINIMUM_REVIEWS_FOR_DISPLAY ? /*#__PURE__*/_jsx(Rating, {
              rating: reviewSummary.overallRating,
              label: reviewSummary.reviewCount,
              showTextRating: true,
              use: "card",
              type: STAR_RATING_FILLED,
              justify: "center"
            }) : /*#__PURE__*/_jsx("span", {})
          }), /*#__PURE__*/_jsx(Small, {
            children: installsCount > 0 ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "marketplace-assets-ui.themes.themeListViewCard.installsBucket.bucket_jsx",
              elements: {
                Number: FormattedNumber
              },
              options: {
                value: installsCount
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.themes.themeListViewCard.installsBucket.min"
            })
          }), (detailsButton || demoButton) && /*#__PURE__*/_jsxs(UIFlex, {
            direction: "row",
            align: "center",
            className: "p-top-2 p-bottom-2",
            wrap: isMobileView ? 'wrap' : 'nowrap',
            children: [detailsButton, demoButton]
          })]
        })]
      })
    })
  }));
};

export default ThemeListViewCard;